import { Typography } from 'antd';
import TitleBar from './TitleBar';

import imageStandard from '@/assets/images/home_banner.png';

import './style.less';
import { useRouteMatch } from 'react-router-dom';
import HelpCenterSearchBox from './SearchBox';

function HelpCenterHeader() {
  const match = useRouteMatch();

  return (
    <>
      <TitleBar />

      <div className="help-center-banner" data-small={!match.isExact}>
        <img src={imageStandard} />
        <div className="container" style={{ zIndex: 2 }}>
          <Typography.Title level={2} className="help-center-banner-title">
            Dúvidas? Veja as nossas funcionalidades e saiba como gerenciar sua
            empresa!
          </Typography.Title>

          <HelpCenterSearchBox />
        </div>
      </div>
    </>
  );
}

export default HelpCenterHeader;
